import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'

export enum ResourceFormsColumnId {
  Checkbox = 'checkbox',
  Name = 'name',
  AssociatedProperties = 'associatedProperties',
  AppliedToCount = 'appliedToCount',
  CreatedBy = 'createdBy',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
}

export interface IResourceFormRow {
  id: string
  resourceTypeId: ResourceTypeId
  name: string
  associatedProperties: number
  appliedToCount: number
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
}
